import { HttpInstance } from "lib/HttpLib";

// [GET] 급여 관리 정보 받아오기
export async function getSalaryInfo(queryData) {
  const { salaryReportId, isEdit } = queryData;

  return await HttpInstance.get(process.env.REACT_APP_SALARY_SERVER + "/salary/global_summary", {
    params: { salary_report_id: salaryReportId, is_edit: isEdit },
  });
}

// [GET] 급여 직원별 현황 정보 받아오기
export async function getSalaryOverallList(queryData) {
  const { salaryReportId, isEdit } = queryData;

  return await HttpInstance.get(process.env.REACT_APP_SALARY_SERVER + "/salary/overall_list", {
    params: { salary_report_id: salaryReportId, is_edit: isEdit },
  });
}

// [GET] 급여 직원 리스트 콤보 받아오기
export async function getSalaryStaffCombo(queryData) {
  const { salaryReportId, isEdit } = queryData;

  return await HttpInstance.get(process.env.REACT_APP_SALARY_SERVER + "/salary/modal", {
    params: { salary_report_id: salaryReportId, is_edit: isEdit },
  });
}
